var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-progress"},[_c('p',[_c('span',[_vm._v("Прогресс прохождения:")]),_c('output',[_vm._v(_vm._s(_vm.number)+"%")])]),_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar__progress",style:(_vm.maxWidth)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }